import { useState } from 'react';

/**
 * FRONT-2936: the Code tab's unsaved edits. Each one keeps the version of the
 * file it started from (`base`, taken at the first keystroke), so Save sends
 * that version and never the one a later refetch put in the cache: a file
 * changed on the app since is refused instead of overwritten.
 */
export interface PendingEdit {
  content: string;
  /** Undefined: the server read no version (an app that keeps no history). */
  base?: string | null;
}

export type EditBuffer = Record<string, PendingEdit>;

/** A keystroke: the text changes, the version stays the one the first keystroke saw. */
export function typed(buffer: EditBuffer, path: string, content: string, shownBase: string | null | undefined): EditBuffer {
  const held = buffer[path];
  return { ...buffer, [path]: { content, base: held ? held.base : shownBase } };
}

export function without(buffer: EditBuffer, path: string): EditBuffer {
  if (!(path in buffer)) return buffer;
  const next = { ...buffer };
  delete next[path];
  return next;
}

/** A rename carries the edit with its version: the version names the content, not the path. */
export function moved(buffer: EditBuffer, from: string, to: string): EditBuffer {
  if (!(from in buffer)) return buffer;
  const next = { ...buffer, [to]: buffer[from] };
  delete next[from];
  return next;
}

export function useEditBuffer() {
  return useState<EditBuffer>({});
}
